document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.js-load')) {
    document.querySelectorAll('.js-load').forEach(elm => {
      elm.classList.add('is-loaded');
    })
  }
})